import { render, staticRenderFns } from "./Roll.vue?vue&type=template&id=32e38f9e"
import script from "./Roll.vue?vue&type=script&lang=js"
export * from "./Roll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports